import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import recommendKeyword from 'api/axios/foka/recommendKeyword'

const initialState = {
  visible: false,
  keywords: [],
  price: 70,
  isLoading: false,
  isRegisteredLoading: false,
  content: [],
  registered: [],
  selected: [],
}

export const fetchPredictKeywords = createAxiosThunk(
  'keywordPlanner/fetchPredictKeywords',
  (noArgs, { getState }) => {
    const { keywords, price } = getState().keywordPlanner.predictKeyword
    const keywordAndPrices = keywords.map(keyword => ({
      keyword,
      price,
    }))
    return recommendKeyword.getPredictKeywords(keywordAndPrices)
  }
)

export const fetchRegisteredKeywords = createAxiosThunk(
  'keywordPlanner/fetchRegisteredKeywords',
  (noArgs, { getState }) => {
    const { keywords } = getState().keywordPlanner.predictKeyword
    return recommendKeyword.getRegisteredKeywords(keywords)
  }
)

const predictKeywordSlice = createSlice({
  name: 'keywordPlanner/predictKeyword',
  initialState,

  reducers: {
    setKeywords: (state, { payload }) => {
      state.keywords = payload
    },
    setPrice: (state, { payload }) => {
      state.price = payload
    },
    setVisible: (state, { payload }) => {
      state.visible = payload
    },
    setSelected: (state, { payload }) => {
      const index = state.selected.indexOf(payload)
      if (index !== -1) {
        state.selected.splice(index, 1)
      } else {
        state.selected.push(payload)
      }
    },
    selectAll: state => {
      state.selected = state.keywords
    },
    clearSelected: state => {
      state.selected = []
    },
    reset: () => initialState,
  },

  extraReducers: builder => {
    builder.addCase(fetchPredictKeywords.pending, state => {
      state.isLoading = true
    })

    builder.addCase(fetchPredictKeywords.fulfilled, (state, { payload }) => {
      state.content = payload
      state.isLoading = false
    })

    builder.addCase(fetchPredictKeywords.rejected, state => {
      state.isLoading = false
    })

    builder.addCase(fetchRegisteredKeywords.pending, state => {
      state.isRegisteredLoading = true
    })

    builder.addCase(fetchRegisteredKeywords.fulfilled, (state, { payload }) => {
      state.registered = payload.content
      state.isRegisteredLoading = false
    })

    builder.addCase(fetchRegisteredKeywords.rejected, state => {
      state.isRegisteredLoading = false
    })
  },
})
const { actions, reducer } = predictKeywordSlice
export const {
  setKeywords,
  setPrice,
  setVisible,
  setSelected,
  selectAll,
  clearSelected,
  reset,
} = actions
export default reducer
